/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandy_Olive_Moth_LickInputs */

const en_sandy_olive_moth_lick = /** @type {(inputs: Sandy_Olive_Moth_LickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile Phone`)
};

const de_sandy_olive_moth_lick = /** @type {(inputs: Sandy_Olive_Moth_LickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobiltelefon`)
};

/**
* | output |
* | --- |
* | "Mobile Phone" |
*
* @param {Sandy_Olive_Moth_LickInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sandy_olive_moth_lick = /** @type {((inputs?: Sandy_Olive_Moth_LickInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandy_Olive_Moth_LickInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sandy_olive_moth_lick(inputs)
	return de_sandy_olive_moth_lick(inputs)
});